theme.LoyaltyPoints = (function() {
  const update = (selector, multiplier, price) => {
  var pointsToEarn = document.querySelectorAll(selector);
    pointsToEarn.forEach((element) => {
      const points = Math.floor(price * multiplier);
      element.innerHTML = points;
    });
    // if (window?.convert?.currentData?.experiences?.["1004182027"]?.variation?.id === "1004428158" || window?.convert?.currentData?.experiences?.["1004182027"]?.variation?.id === "1004429420") {
    //   if (price > 0) {
    //     theme.Notifications.add([{id: 'loyalty-points', message: `Earn <b><span class="loyalty-points__subtotal">${Math.floor(price * multiplier)}</span></b> loyalty points for this purchase! &#127873;`}]);
    //   }
    // }
  };

  return {
    update: update
  };
})();

theme.FreeShippingThreshold = (function() {
  const updateCart = (selector, price, threshold) => {
    const elements = document.querySelectorAll(selector);
    elements.forEach((element) => {
      if (price >= threshold) {
        const message = 'Good news - your order will ship for <b>free</b>! &#127881;';
        element.innerHTML = message;

        if (window?.convert?.currentData?.experiences?.["1004182027"]?.variation?.id === "1004429419" || window?.convert?.currentData?.experiences?.["1004182027"]?.variation?.id === "1004429420") {
          element.parentElement.style.display = 'block';
          theme.Notifications.add([{id: 'free-shipping', message: message}]);
          theme.Notifications.delete(['amount-left', 'shipping-policy']);
        }

      } else if (price < threshold && price / threshold > 0.5) {
        const amountNeeded = threshold - price;
        const message = `Add <span class="free-shipping__amount-left">$${amountNeeded.toFixed(2)}</span> more to get <b>free shipping</b> &#128230;`;
        element.innerHTML = message;

        if (window?.convert?.currentData?.experiences?.["1004182027"]?.variation?.id === "1004429419" || window?.convert?.currentData?.experiences?.["1004182027"]?.variation?.id === "1004429420") {
          element.parentElement.style.display = 'block';
          theme.Notifications.add([{id: 'amount-left', message: message}]);
          theme.Notifications.delete(['free-shipping', 'shipping-policy']);
        }        

      } else {
        const message = `<b>Free shipping</b> on orders over $${threshold} &#128230;`;
        element.innerHTML = message;
        if (window?.convert?.currentData?.experiences?.["1004182027"]?.variation?.id === "1004429419" || window?.convert?.currentData?.experiences?.["1004182027"]?.variation?.id === "1004429420") {
          element.parentElement.style.display = 'block';
          theme.Notifications.add([{id: 'shipping-policy', message: message}]);
          theme.Notifications.delete(['free-shipping', 'amount-left']);
        }        
      }
    });
  };

  const updateProduct = (selector, price, threshold, message) => {
    var shippingMessage = document.querySelector(selector);
    if (price >= threshold) {
      shippingMessage.textContent = message;
      shippingMessage.style.display = 'block';
    } else {
      shippingMessage.textContent = '';
      shippingMessage.style.display = 'none';
    }
  };

  const updateBar = (container, child, price, threshold) => {
    var containers = document.querySelectorAll(container);
    const percentage = Math.min((price / threshold) * 100, 100);

    if (price < threshold && percentage > 50) {
      containers.forEach((container) => {
        const freeShippingBar = container.querySelector(child);
       freeShippingBar.style.width = percentage + '%';
        container.style.display = 'block';
      });
    } else {
      containers.forEach((container) => {
        container.style.display = 'none';
      });
    }
  };

  return {
    updateCart: updateCart,
    updateProduct: updateProduct,
    updateBar: updateBar
  }
})();

theme.Notifications = (function() {
  const STORAGE_KEY = 'new_notifications';
  const bubbles = document.querySelectorAll('.notifications__bubble');

  const getNotifications = () => {
    const jsonString = sessionStorage.getItem('notifications');
    if (jsonString) {
      return JSON.parse(jsonString);
    } else {
      return [];
    }
  };

  const markAsUnread = () => {
    console.log("bubbles:", bubbles);
    localStorage.setItem(STORAGE_KEY, 'true');
    bubble.classList.add('notifications__bubble--visible');
  };

    const createMarkup = (notifications) => {
      let parents = document.querySelectorAll('.notification-list');
  
      parents.forEach((parent) => {
        let elementsToAppend = [];
        notifications.forEach((notification) => {
          let element = document.createElement('div');
          element.classList.add('notification-item', 'unread');
          element.setAttribute('data-id', notification.id);
          element.innerHTML = `
            <p class="notif-text">${notification.message}</p>
          `;
          elementsToAppend.push(element);
        });
        parent.append(...elementsToAppend);
      });
    };
  
  const init = () => {
    const notifications = getNotifications();
    if (notifications.length > 0) {
      createMarkup(notifications);
    }
  };
  
  const checkForExisting = (inputId) => {
    const notifications = getNotifications();
    const match = notifications.find(notification => notification.id === inputId);
    if (match) {
      return true;
    }
    return false;
  };

  const addNotifications = (notifications) => {
    const newNotifications = notifications.filter(notification => {
      return !checkForExisting(notification.id);
    });

    if (newNotifications.length === 0) {
      return;
    }

    createMarkup(newNotifications);
    const existingNotifications = getNotifications();
    const updatedNotifications = existingNotifications.concat(newNotifications);
    sessionStorage.setItem('notifications', JSON.stringify(updatedNotifications));
    markAsUnread();
  };

  const deleteNotifications = (notificationIds) => {
    notificationIds.forEach((id) => {
      const notificationElements = document.querySelectorAll(`[data-id="${id}"]`);
      
      notificationElements.forEach(element => {
        if (element) {
          element.remove();
        }
      });
    });

    const existingNotifications = getNotifications();
    const filteredNotifications = existingNotifications.filter(notification => {
      return !notificationIds.includes(notification.id);
    });
    sessionStorage.setItem('notifications', JSON.stringify(filteredNotifications));
  }

  return {
    get: getNotifications,
    createMarkup: createMarkup,
    init: init,
    add: addNotifications,
    checkForExisting: checkForExisting,
    delete: deleteNotifications
  };
})();

theme.Notifications.init();